import { useBreakpointValue } from '@chakra-ui/react';

export function useCompactView() {
  const isCompactView = useBreakpointValue({ base: true, lg: false });

  return { isCompactView };
}
